import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import Icon from '@mlb/react-patterns/v4/components/Icon/icon';
import COLORS from '@mlb/react-patterns/v4/style/universal.color.ts';
import {
    HighlightHeader,
    HighlightGradient,
    HighlightDuration,
    HighlightPlay,
    MetaInfoWrapper,
    HighlightControlsWrapper
} from './VideoPlayer.style';

const {
    mlbBlack
} = COLORS;

const MetaInfo = ({
    title,
    duration,
    metaVisibility,
    showTitle,
    ...otherProps
}) => {
    if (!metaVisibility) {
        return null;
    }

    return (
        <MetaInfoWrapper {...otherProps}>
            <HighlightGradient />
            <HighlightControlsWrapper>
                <HighlightPlay>
                    <Icon name='play' fill={mlbBlack} width='20' />
                </HighlightPlay>
                <HighlightHeader>
                    {showTitle && title}
                </HighlightHeader>
                <HighlightDuration>
                    {duration?.substring(3) || '0:00'}
                </HighlightDuration>
            </HighlightControlsWrapper>
        </MetaInfoWrapper>
    );
};

MetaInfo.propTypes = {
    title: PropTypes.string,
    duration: PropTypes.string,
    metaVisibility: PropTypes.bool,
    onClick: PropTypes.func,
    showTitle: PropTypes.bool
};

export default withTheme(MetaInfo);
